module.exports = __webpack_public_path__ + "static/confessions-40bad9085d816bbcb3373eba568057e4.jpg";